module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "请选择数据清洗类型"
    }
  }, [_c('div', {
    staticClass: "m-t-10"
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dealType),
      expression: "dealType"
    }],
    domProps: {
      "value": (_vm.dealType)
    },
    on: {
      "input": function($event) {
        _vm.dealType = $event
      }
    }
  }, _vm._l((_vm.dealTypesSource), function(type) {
    return _c('el-checkbox', {
      attrs: {
        "label": type.id
      }
    }, [_vm._v("\n        " + _vm._s(type.name) + "\n        ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sure()
      }
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-852328a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/cleantypeDialog.vue
// module id = 1951
// module chunks = 2